<template lang="pug">

  div.container

    .half-width.margin-auto
      h3.title Cambiar contraseña

      article.message.is-info
        .message-body
          | Ingresa tu nueva contraseña

      .field
        p.control.has-icons-left.has-icons-right
          input.input(type='password', placeholder='Nueva contraseña', v-model="newPassword", @keyup.enter="restablecer")
          span.icon.is-small.is-left
            i.fa.fa-lock

      .field
        p.control.has-icons-left.has-icons-right
          input.input(type='password', placeholder='Repita la nueva contraseña', v-model="repeatNewPassword", @keyup.enter="restablecer")
          span.icon.is-small.is-left
            i.fa.fa-lock

      .field
        p.control.has-text-centered
          button.button.is-primary(@click="restablecer", :class="{'is-loading': isLoading}") Restablecer contraseña


      transition(name="fade")
        article.message.is-danger(v-if="errorMessage")
          .message-body
            strong {{errorMessage}}

</template>

<script>
import { apiPost, notify } from '../util/general'
export default {
  name: 'forgot-password-request',
  data () {
    return {
      newPassword: '',
      repeatNewPassword: '',
      errorMessage: '',
      isLoading: false
    }
  },
  methods: {
    restablecer () {
      var vm            = this
      this.errorMessage = ''

      if (!vm.newPassword || !vm.repeatNewPassword) {
        vm.errorMessage = 'Ingrese la nueva contraseña dos veces'
        return
      }

      if (vm.newPassword !== vm.repeatNewPassword) {
        vm.errorMessage = 'Las contraseñas deben ser iguales'
        return
      }

      this.isLoading    = true

      var obj = {
        newPassword : vm.newPassword,
        dni         : vm.$route.query.dni,
        resetToken  : vm.$route.query.resettoken
      }
      apiPost(vm, '/forgot-password-post', obj, function (data) {
        notify(vm, 'success', 'Contraseña cambiada con exito')
        setTimeout(function () {
          window.location.href = '/'
        }, 1000)
      }, function (error) {
        vm.errorMessage = error.message
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// View_Forgot_Password_Post.vue?e588303e